export default "__VITE_ASSET__Dj6X$3Rm__"